import { useState } from 'react';
import { word } from "shared/types/Report";
import useBatchView, { parseBatchLines } from './useBatchView';
import useStorage from "shared/hooks/useStorage";

const useWordBatchView = (list: word[], setList:React.Dispatch<React.SetStateAction<word[]>>, path:string, onCloseViewHandler:()=>void) => {
    const baseHook = useBatchView(list, setList, path);
    const {uploadStorage} = useStorage();
    const [fileList, setFileList] = useState<File[]>([]);
    const [wordAudioList, setWordAudioList] = useState<File[]>([]);
    const [exampleAudioList, setExampleAudioList] = useState<File[]>([]);
    const [wordList, setWordList] = useState<string[]>([]);
    const [korList, setKorList] = useState<string[]>([]);
    const [exampleList, setExampleList] = useState<string[]>([]);
    const [exampleKorList, setExampleKorList] = useState<string[]>([]);

    const onChangeInputHandler = (name: string, value: string) => {
        const valueList = parseBatchLines(value);
        if(name === "word"){
            setWordList(valueList);
        }else if(name === "kor"){
            setKorList(valueList);
        }else if(name === "example"){
            setExampleList(valueList);
        }else if(name === "example_kor"){
            setExampleKorList(valueList);
        }
    };

    const onRegisterReportClickHandler = async(list:word[]) => {
        try {
            const data = await registerImage(list);
            const audio = await registerAudio(data);
            const register_data = baseHook.removeKeyFromObjects(audio, "image_preview");
            await baseHook.onRegisterReportClick("word", register_data);
        } catch (error) {
            console.error("단어 일괄 등록 실패:", error);
            baseHook.setShowProgress(false);
            baseHook.openSaveFailedError();
        }
    }

    const registerImage = async(list:word[]) => {
        let wordList = list;
        baseHook.setShowProgress(true);
        for(let i = 0; i < list.length; i++){
            const image = list[i].image;
            if (image instanceof File) {
                baseHook.setUploadFileName(image.name);
                const image_url = await uploadStorage(path + "/word", image, baseHook.setProgress).then(res => {
                    return res || "";
                })
                wordList[i].image = image_url;
                wordList[i].image_preview = "";
            }
        }
        baseHook.setShowProgress(false);
        setList(wordList);
        return wordList;
    }

    const registerAudio = async (list:word[]) => {
        let wordList = list;
        baseHook.setShowProgress(true);
      
        for (let i = 0; i < list.length; i++) {
          const wordAudio = wordAudioList[i];
          const exampleAudio = exampleAudioList[i];
      
          if (wordAudio) {
            baseHook.setUploadFileName(`word-audio-${i}.mp3`);
            const audio_url = await uploadStorage(
              path + "/word",
              wordAudio,
              baseHook.setProgress
            ).then((res) => {
              return res || "";
            });
            wordList[i].word_audio = audio_url;
          }

          if (exampleAudio) {
            baseHook.setUploadFileName(`example-audio-${i}.mp3`);
            const audio_url = await uploadStorage(
              path + "/word",
              exampleAudio,
              baseHook.setProgress
            ).then((res) => {
              return res || "";
            });
            wordList[i].example_audio = audio_url;
          }
        }
      
        baseHook.setShowProgress(false);
        return wordList;
      };

    const onSaveClickHandler = () => {
        if(!(wordList.length > 0 &&
            (wordList.length === korList.length || korList.length === 0) && 
            (wordList.length === exampleList.length || exampleList.length === 0) && 
            (exampleList.length === exampleKorList.length || exampleKorList.length === 0) && 
            (wordList.length === fileList.length || fileList.length === 0) &&
            (exampleList.length === exampleAudioList.length || exampleAudioList.length === 0) &&
            (wordList.length === wordAudioList.length || wordAudioList.length === 0))){
            baseHook.openCountMismatchError();
            return;
        }
        const newList:word[] = [];
        for(let i = 0; i < wordList.length; i++){
            newList.push({
                id:i + 1, 
                word:wordList[i] || "", 
                kor:korList[i] || "", 
                example:exampleList[i] || "", 
                example_kor:exampleKorList[i] || "", 
                image:fileList[i] || "",
                word_audio:"",
                example_audio:""
            });
        }
        onRegisterReportClickHandler(newList);
    }

    const onSuccessModalConfirmHandler = () => {
        baseHook.onSuccessModalConfirmHandler();
        onCloseViewHandler();
    }

    return {
        ...baseHook, 
        fileList, 
        setFileList, 
        wordAudioList,
        setWordAudioList,
        exampleAudioList,
        setExampleAudioList,
        onChangeInputHandler, 
        wordList, 
        setWordList, 
        onSaveClickHandler, 
        onSuccessModalConfirmHandler
    };
};

export default useWordBatchView;
